import { SelectBox } from "devextreme-react";
import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import cubeApiClient from "../../../BusinessObjects/cubeApiService";
import LoggedContext from "../../../BusinessObjects/LoggedContext";
import EsaedroLookupItem from "../../../Models/EsaedroLookupItem";
import ResourcesLookups from "../../../Models/ResourcesLookups";
import ResourcesLookupsDisplayFields from "../../../Models/ResourcesLookupsDisplayFields";
import ResourceLookupValue from "../../../Models/SysConf/ResourceLookupValue";
import { DevExtremeComponentName } from "../../../Utils/DevExtremeComponentName";
import {
  themeCol9,
  themeGroup,
  themeSpinner,
} from "../../../Utils/EsaedroTheme";
import { ResourceNames } from "../../../Utils/ResourceNames";
import DelayedDataGrid2 from "../DelayedDataGrid/DelayedDataGrid2";
import { NativeEventInfo } from "devextreme/events";
import { SelectBoxInstance } from "devextreme/ui/select_box";

export interface EsaedroLookupHandleChangeEvent {
  value: any;
  selectedRowsData: any[];
  resourceLookupValues: ResourceLookupValue[];
  fieldName: string;
  component: string;
}

export interface CustomLookupFilter {
  fieldName: string;
  operator: string;
  value: string | number;
}

interface LookupProps {
  fieldName: string;
  value: any;
  fatherObj: any;
  lookupName: string;
  lookupValues: string;
  isValid?: boolean;
  className?: string;
  displayName?: string;
  onChange?(event: EsaedroLookupHandleChangeEvent): void;
  onClear?(event: EsaedroLookupHandleChangeEvent): void;
  onFieldsToCheckLoaded?(lookupName: string, fieldsToCheck: any[]): void;
  items?: EsaedroLookupItem[];
  isSys?: boolean;
  isDisabled?: boolean;
  style?: any;

  filters?: CustomLookupFilter[];
}

interface LookupState {
  lookupResource?: ResourcesLookups;
  items: EsaedroLookupItem[];
  itemsToDisplay: EsaedroLookupItem[];
  columns: ResourcesLookupsDisplayFields[];
  valuesToEditOnChange: ResourceLookupValue[];

  toggleSearch: boolean;
  loading: boolean;
  errorMessage: string;

  valueColumnName: string;
  lookupObjects: any[];
  showClearButton: boolean;
}

const descString = "_description";
const valString = "_value";

export default class Lookup extends Component<LookupProps, LookupState> {
  static contextType = LoggedContext;
  context!: React.ContextType<typeof LoggedContext>;

  // Campi che manipolano il rendering
  filterFailed: boolean = false;
  fieldsToCheck: any[] = [];
  initialDisplayField: string = "";

  constructor(props: LookupProps) {
    super(props);

    this.state = {
      items: [],
      itemsToDisplay: [],
      columns: [],
      valuesToEditOnChange: [],

      toggleSearch: false,
      loading: false,
      errorMessage: "",

      valueColumnName: "",
      lookupObjects: [],
      showClearButton: true,
    };
  }

  componentDidMount() {
    this.getLookupData();
  }

  // Recupero le informazioni sulla lookup(Colonne, Valori, ecc...)
  getLookupData = () => {
    // Questo metodo viene chiamato solo alla DidMount, e popola la lookup
    this.setState({ loading: true });

    if (this.props.lookupValues) {
      let valuesToShow = this.props.lookupValues.split("|");

      let newItems: EsaedroLookupItem[] = [];
      let newItemsToDisp: EsaedroLookupItem[] = [];

      valuesToShow.forEach((element) => {
        var v = element.split("=");
        newItems.push(new EsaedroLookupItem(v[0].toString(), v[1]));
        newItemsToDisp.push(new EsaedroLookupItem(v[0].toString(), v[1]));
      });

      this.setState({
        items: newItems,
        itemsToDisplay: newItemsToDisp,
        loading: false,
      });
    } else if (this.props.lookupName) {
      // Col lookupName vado a richiedere i dettagli della lookup

      const service = new cubeApiClient();
      const t = this.context.tokenAPI;
      var requrl = `api/sys/${
        ResourceNames.ResourcesLookups
      }?RecordSelection=${encodeURIComponent(
        "LookupName='" + this.props.lookupName + "'"
      )}`;

      service.getItems(requrl, t).then(
        (data: any) => {
          if (data) {
            var resourceLookup: ResourcesLookups = data[0];

            if (resourceLookup) {
              let columnToRender: ResourcesLookupsDisplayFields[] = [];
              let valueColumnName: string = "";
              let valuesToEditOnChange: ResourceLookupValue[] = [];
              let showClearButton: boolean = true;

              if (resourceLookup.ShowClearButton !== undefined) {
                showClearButton = resourceLookup.ShowClearButton;
              }

              if (resourceLookup.ResourcesLookupsDisplayFields.length >= 1) {
                resourceLookup.ResourcesLookupsDisplayFields.forEach(
                  (field: ResourcesLookupsDisplayFields) => {
                    columnToRender.push(field);
                  }
                );
              }

              // Recupero il valueColumnName (serve nella DalayedDataGrid per il keyExpr e per l'handleChange) partendo dal ParentField_Name
              if (resourceLookup.ResourcesLookupsLinkFields.length >= 1) {
                resourceLookup.ResourcesLookupsLinkFields.forEach(
                  (field: any) => {
                    if (field.ParentField_Name === this.props.fieldName)
                      valueColumnName = field.LookupField_Name;
                  }
                );
              }

              if (resourceLookup.ResourcesLookupsValues) {
                valuesToEditOnChange = resourceLookup.ResourcesLookupsValues;
              }

              // Compilo i fieldsToCheck
              if (resourceLookup.ResourcesLookupsFilters) {
                for (
                  let i = 0;
                  i < resourceLookup.ResourcesLookupsFilters.length;
                  i++
                ) {
                  if (
                    resourceLookup.ResourcesLookupsFilters[i].ParentField_Name
                  )
                    this.fieldsToCheck.push(
                      resourceLookup.ResourcesLookupsFilters[i].ParentField_Name
                    );
                }
                // Invoco il callback per salvare i fields to check della lookup
                this.sendFieldsToCheckToParent(
                  resourceLookup.ValueField_Name,
                  this.fieldsToCheck
                );
              }

              // Setto la resourceLookup
              this.setState(
                {
                  lookupResource: resourceLookup,
                  columns: columnToRender,
                  valueColumnName: valueColumnName,
                  valuesToEditOnChange: valuesToEditOnChange,
                  showClearButton: showClearButton,
                },
                () => {
                  // Se non ha LoadOnClick allora chiedo già i campi
                  if (!resourceLookup.LoadOnClick)
                    this.reloadResourceLookupFields();
                  else {
                    // Ottengo la descrizione del primo Item
                    let filterString =
                      "?RecordSelection=" +
                      resourceLookup.ValueField_Name +
                      " = '" +
                      this.props.value +
                      "'";
                    // Applico i filtri in caso ce ne siano
                    if (
                      resourceLookup.ResourcesLookupsFilters &&
                      this.props.fatherObj
                    ) {
                      this.fieldsToCheck = [];
                      for (
                        let i = 0;
                        i < resourceLookup.ResourcesLookupsFilters.length;
                        i++
                      ) {
                        this.fieldsToCheck.push(
                          resourceLookup.ResourcesLookupsFilters[i]
                            .ParentField_Name
                        );
                        if (
                          this.props.fatherObj[
                            resourceLookup.ResourcesLookupsFilters[i]
                              .ParentField_Name
                          ]
                        ) {
                          filterString +=
                            " and " +
                            resourceLookup.ResourcesLookupsFilters[i]
                              .LookupField_Name +
                            resourceLookup.ResourcesLookupsFilters[i]
                              .FilterOperator +
                            "'" +
                            this.props.fatherObj[
                              resourceLookup.ResourcesLookupsFilters[i]
                                .ParentField_Name
                            ] +
                            "'";
                        } else this.filterFailed = true;
                      }
                      if (this.filterFailed)
                        filterString = "?RecordSelection=1=0";
                    }

                    var requrl =
                      resourceLookup.Resource_Endpoint + filterString;

                    service.getItems(requrl, t).then(
                      (elenco: any) => {
                        // Se trovo l'oggetto, allora setto la descrizione completa
                        if (elenco.length) {
                          var element = elenco[0];
                          if (element) {
                            var descriptionField: string = "";
                            // Salvo i campi su cui poi filtrerò e intanto mi ricreo la descrizione completa
                            for (
                              var idxFields = 0;
                              idxFields <
                              resourceLookup.ResourcesLookupsDisplayFields
                                .length;
                              idxFields++
                            ) {
                              descriptionField =
                                descriptionField +
                                (idxFields ? " | " : "") +
                                element[
                                  resourceLookup.ResourcesLookupsDisplayFields[
                                    idxFields
                                  ].DisplayField_Name
                                ];
                            }
                            // Mi salvo la descrizione completa a lookup non ancora caricata
                            this.initialDisplayField = descriptionField;
                            this.setState({ loading: false });
                          } else {
                            this.setState({ loading: false });
                          }
                        } else {
                          this.setState({
                            loading: false,
                          });
                        }
                      },
                      (error: any) => {
                        this.setState({
                          loading: false,
                          errorMessage: error,
                        });
                      }
                    );
                  }
                }
              );
            } else {
              this.setState({
                loading: false,
              });
            }
          } else {
            this.setState({
              loading: false,
            });
          }
        },
        (error: any) => {
          // Non ho trovato i dettagli della Resource Lookup
          this.setState({
            loading: false,
            errorMessage: error,
          });
        }
      );
    } else {
      //Ultima spiaggia...valori items presi dal padre
      if (this.props.items !== undefined) {
        this.setState({
          items: this.props.items,
          itemsToDisplay: this.props.items,
          loading: false,
        });
      } else this.setState({ loading: false });
    }
  };

  sendFieldsToCheckToParent = (fieldName: string, fieldsToCheck: any[]) => {
    // Tramite callback manda alla ObjectEdit i campi da controllare per scatenare il re-rendering della lookup
    if (this.props.onFieldsToCheckLoaded)
      this.props.onFieldsToCheckLoaded(fieldName, fieldsToCheck);
  };

  reloadResourceLookupFields = () => {
    // Ricarica i campi della lookup
    this.setState({ loading: true, toggleSearch: false });

    //Elenco da lookup resource
    if (this.state.lookupResource) {
      let resourceLookup: ResourcesLookups = this.state.lookupResource;

      let recSelString = "?RecordSelection=";
      let filterString = "";
      // Applico i filtri in caso ce ne siano
      if (resourceLookup.ResourcesLookupsFilters && this.props.fatherObj) {
        this.fieldsToCheck = [];
        this.filterFailed = false;

        for (
          var i = 0;
          i < resourceLookup.ResourcesLookupsFilters.length;
          i++
        ) {
          if (resourceLookup.ResourcesLookupsFilters[i].ParentField_Name) {
            this.fieldsToCheck.push(
              resourceLookup.ResourcesLookupsFilters[i].ParentField_Name
            );

            if (
              this.props.fatherObj[
                resourceLookup.ResourcesLookupsFilters[i].ParentField_Name
              ]
            ) {
              filterString +=
                (i ? " and " : "") +
                resourceLookup.ResourcesLookupsFilters[i].LookupField_Name +
                resourceLookup.ResourcesLookupsFilters[i].FilterOperator +
                "'" +
                this.props.fatherObj[
                  resourceLookup.ResourcesLookupsFilters[i].ParentField_Name
                ] +
                "'";
            } else {
              this.filterFailed = true;
            }
          } else if (resourceLookup.ResourcesLookupsFilters[i].FixedValue) {
            filterString +=
              (i ? " and " : "") +
              resourceLookup.ResourcesLookupsFilters[i].LookupField_Name +
              resourceLookup.ResourcesLookupsFilters[i].FilterOperator +
              "'" +
              resourceLookup.ResourcesLookupsFilters[i].FixedValue +
              "'";
          }
        }

        if (this.filterFailed) filterString = "1=1";
      }

      const service = new cubeApiClient();
      const t = this.context.tokenAPI;

      var requrl =
        resourceLookup.Resource_Endpoint +
        (filterString > ""
          ? recSelString + encodeURIComponent(filterString)
          : "");

      if (this.props.filters) {
        requrl += filterString.length > 0 ? " and " : "?RecordSelection=";
        for (let i = 0; i < this.props.filters.length; i++) {
          requrl +=
            (i ? " and " : "") +
            this.props.filters[i].fieldName +
            this.props.filters[i].operator +
            "'" +
            this.props.filters[i].value +
            "'";
        }
      }

      service.getItems(requrl, t).then(
        (elenco: any) => {
          if (elenco) {
            let newItems: EsaedroLookupItem[] = [];
            let newItemsToDisp: EsaedroLookupItem[] = [];

            for (var i = 0; i < elenco.length; i++) {
              var element = elenco[i];
              var descriptionField: string = "";

              for (
                var idxFields = 0;
                idxFields < resourceLookup.ResourcesLookupsDisplayFields.length;
                idxFields++
              ) {
                descriptionField =
                  descriptionField +
                  (idxFields ? " | " : "") +
                  element[
                    resourceLookup.ResourcesLookupsDisplayFields[idxFields]
                      .DisplayField_Name
                  ];
              }

              newItems.push(
                new EsaedroLookupItem(
                  element[resourceLookup.ValueField_Name].toString(),
                  descriptionField
                )
              );
              newItemsToDisp.push(
                new EsaedroLookupItem(
                  element[resourceLookup.ValueField_Name].toString(),
                  descriptionField
                )
              );
            }

            this.setState({
              items: newItems,
              itemsToDisplay: newItemsToDisp,
              lookupObjects: elenco,
              loading: false,
            });
          } else {
            this.setState({
              loading: false,
            });
          }
        },
        (error: any) => {
          this.setState({
            loading: false,
            errorMessage: error,
          });
        }
      );
    } else {
      this.setState({ loading: false });
    }
  };

  // Open the lookup pressing arrow button down when i'm in a lookup

  handleChange = (e: any) => {
    //Propago l'evento alla ObjectEdit
    //Proviene dal selectionChange delle DelayedDataGrid

    if (this.props.onChange) {
      let value = undefined;
      let selectedRowsData = [];

      if (e.value === null || e.value === undefined || e.value === "") {
        if (
          this.state.columns.length > 1 &&
          e.selectedRowKeys &&
          e.selectedRowKeys.length > 0
        ) {
          for (let key in e.currentSelectedRowKeys[0]) {
            if (key === e.element.attributes.columnName.nodeValue) {
              value = e.selectedRowsData[0][key];
              selectedRowsData = e.selectedRowsData;
            }
          }
        } else {
          value = null;
        }
      } else {
        if (this.state.columns.length > 1) {
          for (let key in e.currentSelectedRowKeys[0]) {
            if (key === e.element.attributes.columnName.nodeValue) {
              value = e.selectedRowsData[0][key];
              selectedRowsData = e.selectedRowsData;
            }
          }
        } else {
          value = e.value;
          if (this.state.lookupObjects) {
            let valueFieldName = "";

            if (this.state.lookupResource?.ValueField_Name)
              valueFieldName = this.state.lookupResource.ValueField_Name;

            //(x[valueFieldName] == e.value) Da confermare ==
            if (valueFieldName.length > 0) {
              let tmpSelectedObj = this.state.lookupObjects.find(
                (x) => x[valueFieldName] == e.value
              );
              if (tmpSelectedObj) selectedRowsData.push(tmpSelectedObj);
            }
          }
        }
      }

      let event: EsaedroLookupHandleChangeEvent = {
        value: value,
        selectedRowsData: selectedRowsData,
        resourceLookupValues: this.state.valuesToEditOnChange,
        fieldName: this.props.fieldName,
        component:
          this.state.columns.length > 1
            ? DevExtremeComponentName.DataGrid
            : DevExtremeComponentName.SelectBox,
      };

      this.props.onChange(event);
    }
  };

  handleOpenClickingArrowDown = (
    e: NativeEventInfo<SelectBoxInstance, KeyboardEvent>
  ) => {
    // @ts-ignore
    if (e.event.originalEvent.key === "Shift") {
      e.component.open();
    }
  };

  render() {
    // Come prima cosa renderizzo oggetti che mi serviranno in caso di lookupResource
    let lookupLabel = undefined;

    if (
      this.state.lookupResource /*&& this.state.lookupResource.LoadOnClick*/
    ) {
      lookupLabel = (
        <label htmlFor={this.initialDisplayField}>
          {this.initialDisplayField}
        </label>
      );
    }

    if (this.state.loading) {
      return (
        <Row
          className={this.props.className ? this.props.className : themeGroup()}
        >
          <Col className={themeCol9()}>
            <i className={themeSpinner()}></i> Caricamento...
          </Col>
        </Row>
      );
    }

    if (!this.state.itemsToDisplay.length) {
      if (this.filterFailed) {
        // Non ci sono perchè mancano dei campi richiesti - Metto una combo vuota in ogni caso
        return (
          <SelectBox
            className={
              this.props.className ? this.props.className : themeGroup()
            }
            id={this.props.fieldName}
            elementAttr={{
              field: this.props.fieldName,
            }}
            value={this.props.value}
            name={this.props.fieldName}
            onChange={this.handleChange}
            disabled={this.props.isDisabled}
            dataSource={[]}
          />
        );
      } else if (
        this.state.lookupResource &&
        this.state.lookupResource.LoadOnClick
      ) {
        // Non ci sono perchè è una LoadOnClick - Metto il campo placeholder e renderizzo il tasto cerca
        return <>{lookupLabel}</>;
      } else {
        return (
          <Row
            className={
              this.props.className ? this.props.className : themeGroup()
            }
          >
            <Col className={themeCol9()}>Nessun dato disponibile...</Col>
          </Row>
        );
      }
    }

    //Per ora di LoadOnClick = true nel DB non ce ne sono
    if (this.state.lookupResource && this.state.lookupResource.LoadOnClick) {
      return (
        <SelectBox
          dataSource={this.state.itemsToDisplay}
          displayExpr={descString}
          valueExpr={valString}
          name={this.props.fieldName}
          value={this.props.value}
          onValueChanged={this.handleChange}
          disabled={this.props.isDisabled}
          id={this.props.fieldName}
          elementAttr={{
            field: this.props.fieldName,
          }}
        />
      );
    }

    if (this.state.columns.length <= 1) {
      /*
                Metto il toString(), poichè la SelectBox fa un itemsToDisplay.find() e controlla anche il typeof(this.props.value).
                Se il typeof(this.props.value) === 'number' e value negli itemsToDisplay è un string, la SelectBox non trova nulla.
                Per risolvere ciò metto tutto a stringa.

                TODO -> capire se mettere il toString() quando faccio getLookupData() o farmi passare dal backend i value come string 
            */
      let myValue =
        this.props.value !== undefined && this.props.value !== null
          ? this.props.value.toString()
          : this.props.value;

      return (
        <SelectBox
          dataSource={this.state.itemsToDisplay}
          displayExpr={descString}
          valueExpr={valString}
          name={this.props.fieldName}
          value={myValue}
          onValueChanged={this.handleChange}
          disabled={this.props.isDisabled}
          id={this.props.fieldName}
          elementAttr={{
            field: this.props.fieldName,
          }}
          showClearButton={this.state.showClearButton}
          searchEnabled={true}
          searchMode="contains"
          searchExpr={descString}
          searchTimeout={200}
          minSearchLength={0}
          showDataBeforeSearch={false}
          style={this.props.style ? this.props.style : null}
          isValid={this.props.isValid !== undefined ? this.props.isValid : true}
          onKeyDown={(e) => this.handleOpenClickingArrowDown(e)}
        />
      );
    } else {
      return (
        <DelayedDataGrid2
          gridColumns={this.state.columns}
          gridValue={this.props.value}
          itemsToDisplay={this.state.itemsToDisplay}
          dataGridObjects={this.state.lookupObjects}
          fieldName={this.props.fieldName}
          valueColumnName={this.state.valueColumnName}
          handleChange={this.handleChange}
          gridDisabled={this.props.isDisabled}
          isValid={this.props.isValid}
          showClearButton={this.state.showClearButton}
          onKeyDown={this.handleOpenClickingArrowDown}
        />
      );
    }
  }
}
